import Unit from "../entities/unit";
import UnitStatus from "../entities/valueObjects/unitStatus";

export default class UnitDTO {
  public static fromJson(json: any): Unit {
    return new Unit(
      json.id,
      json.quantity,
      json.price,
      json.description,
      new UnitStatus(json.status),
      json.projectPlanId,
      json.priceHistory,
      json.block,
      json.unitType,
      json.complement,
      json.number,
      {
        rua: json.street || "",
        numero: json.number || "",
        bairro: json.neighborhood || "",
        cidade: json.city || "",
      }
    );
  }
}
